import axios from "axios";

export const IMAGES = {
  homeHero:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_manifest-audio-3/artifacts/6xsgo6qt_ChatGPT%20Image%20Jul%2020%2C%202026%2C%2008_00_07%20PM.png",
  howItWorksHero:
    "https://static.prod-images.emergentagent.com/jobs/bb43803b-7c2b-450c-a8f4-a025ed12aad3/images/e68389311b8796534d06e0f454e20a9cd925852ba27014ffb96309f6afd53244.jpeg",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Starts a Stripe Checkout session and redirects the browser to it.
export async function startCheckout() {
  try {
    const res = await axios.post(`${API}/payments/checkout`, {
      package_id: "audio",
      origin_url: window.location.origin,
    });
    window.location.href = res.data.checkout_url;
  } catch (e) {
    alert("Sorry, we couldn't start checkout. Please try again.");
  }
}
